export default "__VITE_ASSET__CFTg3Wwi__"